import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { CompanyService } from '@services/company.service';
import { Loading } from '@rd-web-markets/shared/dist/util';
import CompanyV2Header from './CompanyV2Header';
import CompanyFolderAndFileManagement from './CompanyFolderAndFileManagement';
import { useSetCompanyBreadcrumb } from '@rd-web-markets/shared/dist/util/hooks/useSetCompanyBreadcrumb';
import { Card } from 'react-bootstrap';

const CompanyDocumentsPage = ({ accountType }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = CompanyService.useGet({ companyId: id, setLoading });

  useSetCompanyBreadcrumb(company, accountType);

  if (!company) return <Loading />;

  const getFileUploadersAndVirtualFolderPath = () => ({
    fileUploaderUsers: company.file_uploader_users || [],
    virtualFolderPath: company.virtual_folder_path || [],
  });

  return (
    <>
      <CompanyV2Header company={company} accountType={accountType} activeTab="documents" />
      <div style={{ maxWidth: '95%', margin: '0 auto', padding: '1.5rem 3rem 2rem' }}>
        <Card>
          <Card.Body>
              <CompanyFolderAndFileManagement
                companyId={id}
                accountType={accountType}
                modelName={company.name}
                getFileUploadersAndVirtualFolderPath={getFileUploadersAndVirtualFolderPath}
              />
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default CompanyDocumentsPage;
